import Breadcrumbs, { BreadcrumbsProps } from "@mui/material/Breadcrumbs";
import { styled } from "@mui/material/styles";

export type EmtBreadcrumbsProps = Omit<BreadcrumbsProps, "variant"> & {
  variant?: string;
  nonce?: string;
};

const StyledBreadcrumbs = styled(Breadcrumbs)(
  (props: EmtBreadcrumbsProps) => ({})
);

export function EmtBreadcrumbs(props: EmtBreadcrumbsProps) {
  const { maxItems = 4, ...rest } = props;

  return <StyledBreadcrumbs maxItems={maxItems} {...rest} />;
}
